import { render, staticRenderFns } from "./portfolio-grid-4-column.vue?vue&type=template&id=0a989a27&"
import script from "./portfolio-grid-4-column.vue?vue&type=script&lang=js&"
export * from "./portfolio-grid-4-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports